export const LOGIN_END_POINT = '/api/token'
export const USER_INFO_END_POINT = '/api/account/userinfo'
export const ACCOUNT_ALL_END_POINT = '/api/account/all'
export const ACCOUNT_SET_PASSWORD_END_POINT = '/api/account/setpassword'
export const ACCOUNT_SET_EMAIL_END_POINT = '/api/account/setemail'
export const ACCOUNT_DELETE_END_POINT = '/api/account/delete'
export const ACCOUNT_CREATE_END_POINT = '/api/account/create'
export const ACCOUNT_ROLES_END_POINT = '/api/account/roles'
export const ACCOUNT_ASSIGN_ROLE_END_POINT = '/api/account/assignrole'
export const ACCOUNT_UNASSIGN_ROLE_END_POINT = '/api/account/removerole'
export const ACCOUNT_SYNC = '/api/account/sync'
export const ACCOUNT_UPDATE = '/api/account/update'



// WEBPACK FOOTER //
// ./src/api/auth/types.js